import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    windowHeight: 0
  },
  mutations: {
    updateWindowHeight(state, value) {
      state.windowHeight = value
    }
  },
  actions: {
    commitWindowHeight({commit}, payload) {
      commit('updateWindowHeight', payload)
    }
  },
  getters: {
    getWindowHeight: state => state.windowHeight
  }
})
